module.exports = __webpack_public_path__ + "static/media/edi2.1b9ac84a.jpeg";